"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useShopifyStickerData = void 0;
const client_1 = require("@apollo/client");
const react_1 = require("react");
const MapmakerApi_1 = require("../MapmakerApi");
(0, client_1.gql) `
  fragment StickerVariantForPricing on StorefrontProductVariant {
    id
    title
    priceV2 {
      currencyCode
      amount
    }
    stickerSizeClass: metafield(
      namespace: "mapmaker"
      key: "sticker.sizeClass"
    ) {
      value
    }
    stickerOutputType: metafield(
      namespace: "mapmaker"
      key: "sticker.outputType"
    ) {
      value
    }
    stickerTokens: metafield(namespace: "mapmaker", key: "sticker.tokens") {
      value
    }
    tokenRedemptionVariant: metafield(
      namespace: "mapmaker"
      key: "sticker.tokenRedemptionVariant"
    ) {
      value
    }
  }

  query getStickerProducts {
    stickers: storefrontCollectionByHandle(handle: "sticker-products") {
      products(first: 10, sortKey: PRICE) {
        edges {
          node {
            id
            variants(first: 20) {
              edges {
                node {
                  ...StickerVariantForPricing
                }
              }
            }
          }
        }
      }
    }
  }
`;
function useShopifyStickerData() {
    const _a = (0, MapmakerApi_1.useGetStickerProductsQuery)(), { data } = _a, rest = __rest(_a, ["data"]);
    const stickerSetMap = (0, react_1.useMemo)(() => {
        var _a;
        if (!data) {
            return {};
        }
        else {
            return (_a = data === null || data === void 0 ? void 0 : data.stickers) === null || _a === void 0 ? void 0 : _a.products.edges.reduce((stickerSetMap, edge) => {
                edge.node.variants.edges.forEach(({ node: variant }) => {
                    const metadata = getShopifyMetadata(variant);
                    if (!metadata) {
                        return;
                    }
                    if (!stickerSetMap[metadata.outputType]) {
                        stickerSetMap[metadata.outputType] = {
                            tokenRedemptionVariantId: undefined,
                            variants: [],
                        };
                    }
                    if (metadata.tokenRedemptionVariant) {
                        stickerSetMap[metadata.outputType].tokenRedemptionVariantId =
                            variant.id;
                    }
                    else {
                        stickerSetMap[metadata.outputType].variants.push(Object.assign({ shopifyVariantId: variant.id, name: variant.title, price: parseFloat(variant.priceV2.amount) }, metadata));
                        stickerSetMap[metadata.outputType].variants.sort((a, b) => a.price < b.price ? -1 : a.price > b.price ? 1 : 0);
                    }
                });
                return stickerSetMap;
            }, {});
        }
    }, [data]);
    return Object.assign({ stickerSetMap }, rest);
}
exports.useShopifyStickerData = useShopifyStickerData;
function getShopifyMetadata(variant) {
    var _a, _b, _c, _d, _e;
    const outputType = variant.stickerOutputType.value;
    if (!((_a = variant.stickerOutputType) === null || _a === void 0 ? void 0 : _a.value)) {
        return null;
    }
    if (((_b = variant.tokenRedemptionVariant) === null || _b === void 0 ? void 0 : _b.value) === "true") {
        return {
            outputType,
            tokenRedemptionVariant: true,
        };
    }
    else {
        if (((_c = variant.stickerTokens) === null || _c === void 0 ? void 0 : _c.value) || ((_d = variant.stickerSizeClass) === null || _d === void 0 ? void 0 : _d.value)) {
            return {
                //    price: parseFloat(variant.priceV2.amount),
                tokenRedemptionVariant: false,
                outputType,
                sizeClass: (_e = variant.stickerSizeClass) === null || _e === void 0 ? void 0 : _e.value,
                tokens: parseFloat(variant.stickerTokens.value),
            };
        }
    }
    return null;
}
//# sourceMappingURL=data:application/json;base64,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